import React from 'react';

import classes from './Placeholder.module.scss';

const Placeholder = ({ width = '100%', height = '100%' }) => {
  return <div className={classes['placeholder']} style={{ width, height }}></div>;
};

export default Placeholder;
